import {ChangeDetectionStrategy, Component, ElementRef, Injectable, Input} from "@angular/core";
import {KommentarModell, OppgaveId, OppgaveModell, OpprettKommentarSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Observable} from "rxjs";
import {KommentarDatatjeneste} from "felles-ng2/tjenester/datalager/KommentarDatatjeneste";
import {KommentarTraaderKomponent} from "web-ng2/moduler/kommentar/komponenter/kommentar-traader/kommentar-traader";
import {NyKommentarTraadKomponent, NyKommentarTraadKomponentAvhengigheter, NyKommentarTraadKomponentAvhengigheter_DI_TOKEN} from "web-ng2/moduler/kommentar/komponenter/ny-kommentar-traad/ny-kommentar-traad";
import {scrollDersomNødvendig} from "web-ng2/delt/dom/scrollIntoView";

const debug = initDebugger('OppgaveKommentarerKomponent');

@Component({
    selector: 'oppgave-kommentarer',
    templateUrl: 'oppgave-kommentarer.html',
    styleUrl: 'oppgave-kommentarer.scss',
    host: {'data-testid': 'kommentarer'},
    imports: [
        KommentarTraaderKomponent,
        NyKommentarTraadKomponent
    ],
    providers: [
        { provide: NyKommentarTraadKomponentAvhengigheter_DI_TOKEN, useExisting: OppgaveKommentarerKomponent },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OppgaveKommentarerKomponent implements NyKommentarTraadKomponentAvhengigheter {
    static ajsSelector = 'oppgaveKommentarer';

    //kan ikke bruker signal da komp brukes i ajs
    @Input({required: true}) oppgave!: OppgaveModell;
    @Input() visNyTraadSkjema: boolean = false;

    constructor(private avhengigheter: OppgaveKommentarerKomponentAvhengigheter, private el: ElementRef) {
    }

    nyTraadFullSkjemaAktivert(aktivert: boolean) {
        if (!aktivert) return;
        //sørger for at bunnen av skjema vises (siden oppgave-kommentarer er siste element på sakssiden)
        scrollDersomNødvendig(this.el.nativeElement, 50);
    }

    //NyKommentarTraadKomponentAvhengigheter implementasjon

    async opprettKommentar(spesifikasjon: OpprettKommentarSpesifikasjon): Promise<void> {
        await this.avhengigheter.opprettKommentar(this.oppgave!.id, spesifikasjon);
    }

    //private hjelpemetoder

}

@Injectable()
export class OppgaveKommentarerKomponentAvhengigheter {

    constructor(private kommentarDatatjeneste: KommentarDatatjeneste) {
    }

    kommentarer(forelder: OppgaveId): Observable<KommentarModell[]> {
        return this.kommentarDatatjeneste.finnTilknyttetFraLokallager(forelder);
    }

    async opprettKommentar(oppgaveId: OppgaveId, spesifikasjon: OpprettKommentarSpesifikasjon): Promise<void> {
        await this.kommentarDatatjeneste.opprettKommentarPåOppgave(oppgaveId, spesifikasjon);
    }
}
